import { Box, Button, Typography } from '@mui/material';
import { BLUE, ERROR_TEXT, INTER, RED } from '../studentStyles';
import { MediaFailure } from './useMockMediaFailure';

const messages: Record<MediaFailure, { text: string; action: string }> = {
    microphone: { text: 'Microphone access is off. Allow microphone access in your browser, then try again.', action: 'Try microphone again' },
    silence: { text: 'We couldn’t hear you. Check your microphone and record again. This doesn’t count as an attempt.', action: 'Record again' },
    scoring: { text: 'We couldn’t check your pronunciation. Your recording is still here. Try checking it again.', action: 'Retry checking' },
    network: { text: 'Your recording couldn’t be sent. Check your connection, then try again. Your recording is still here.', action: 'Retry sending' },
    audio: { text: 'This audio couldn’t play. Try again, or return to your lessons and come back later.', action: 'Try audio again' },
};

export default function MediaErrorNotice({ failure, onRetry }: { failure: MediaFailure; onRetry: () => void }) {
    const message = messages[failure];
    return <Box role="alert" sx={{ p: 2, borderRadius: '14px', bgcolor: `${RED}0C`, maxWidth: '100%' }}>
        <Typography sx={{ fontFamily: INTER, fontSize: 13, lineHeight: 1.5, color: ERROR_TEXT }}>{message.text}</Typography>
        <Button onClick={onRetry} sx={{ mt: 0.5, minHeight: 44, color: BLUE, fontFamily: INTER, fontWeight: 700, textTransform: 'none' }}>{message.action}</Button>
    </Box>;
}
